import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Placeholder } from "react-bootstrap";
import {
  getCircularApi,
  getTEReportList,
} from "../../../../services/DocumentService";
import ReportDetails from "./ReportDetails";
import EditCircularSheet from "./EditCircular";

const CircularDetailsLoading = () => {
  return (
    <div>
      <div className="card">
        <div className="card-body">
          <div className="w-100 px-2 mt-3">
            <Placeholder animation="glow">
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
              <Placeholder
                xs={12}
                style={{ height: "20px" }}
                className="rounded my-2"
              />
            </Placeholder>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-data-center justify-content-between">
            <div className="w-100 px-2">
              <Placeholder animation="glow">
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
              </Placeholder>
            </div>

            <div className="w-100 px-2">
              <Placeholder animation="glow">
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
                <Placeholder
                  xs={12}
                  style={{ height: "20px" }}
                  className="rounded my-2"
                />
              </Placeholder>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function CircularDetails() {
  const [data, setData] = useState(null);
  const [report, setReport] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const tesheetid = location.state?.id || "";
  const { id } = useParams();

  const fetchReport = useCallback(async () => {
    try {
      const resp = await getTEReportList(id);
      setReport(resp.data.results);
    } catch (error) {
      console.error("Error fetching report:", error);
    }
  }, []);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const resp = await getCircularApi(id);
      const respData = resp.data.results;
      setData(respData);
      fetchReport();
    } catch (error) {
      console.error("Error fetching audit data:", error);
      setData(null);
    } finally {
      setIsLoading(false);
    }
  }, [id, fetchReport]);

  useEffect(() => {
    fetchData();
  }, [id, fetchData]);

  const handleAfterUpdate = (updatedData) => {
    setData((prevData) => ({
      ...prevData,
      ...updatedData,
    }));
  };

  const renderBadge = (status) => {
    const statusClasses = {
      draft: "badge light border-0 badge-secondary badge-sm",
      pending: "badge light border-0 badge-warning badge-sm",
      issued: "badge light border-0 badge-primary badge-sm",
      reviewed: "badge light border-0 badge-info badge-sm",
      rejected: "badge light border-0 badge-danger badge-sm",
      default: "badge light border-0 badge-success badge-sm",
    };

    return (
      <span
        className={`badge ${statusClasses[status] || statusClasses.default}`}
      >
        {status}
      </span>
    );
  };

  return (
    <div className="container-fluid">
      {isLoading ? (
        <CircularDetailsLoading />
      ) : data ? (
        <div className="row">
          <div className="col-md-4">
            <div className="card shadow-sm">
              <div className="card-header">
                <div className="d-flex align-items-center justify-content-between w-100">
                  <div className="d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm btn-circle"
                      onClick={() => navigate(`/te-sheet/${tesheetid}`)}
                    >
                      <i className="fa-solid fa-arrow-left"></i>
                    </button>
                    <h4 className="mb-0 ms-2">Circular Details</h4>
                  </div>
                  <div>
                    <EditCircularSheet
                      data={data}
                      handleAfterUpdate={handleAfterUpdate}
                    />
                  </div>
                </div>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <strong>Title:</strong> {data?.title}
                  </li>
                  <li className="mb-3">
                    <strong>Measurement Sheet:</strong>{" "}
                    {data?.measurement_sheet?.title}
                  </li>
                  <li className="mb-3">
                    <strong>Document:</strong>{" "}
                    {data?.measurement_sheet?.document?.title}
                  </li>{" "}
                  <li className="mb-3">
                    <strong>Schedule At:</strong>{" "}
                    {data?.circular_schedule?.schedule_at}
                  </li>{" "}
                  <li className="mb-3">
                    <strong>Status:</strong> {renderBadge(data?.status)}
                  </li>
                </ul>
                {data.status === "approved" && !report?.circular && (
                  <button
                    className="btn btn-outline-primary w-100 mt-3"
                    onClick={() =>
                      navigate(`/circular-report`, { state: { data } })
                    }
                  >
                    <i className="fa-solid fa-file-pdf me-2"></i>Generate Report
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <div className="card shadow-sm">
              <div className="card-header">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <h5 className="mb-0 ms-2">Report Details</h5>
                </div>
              </div>
              <div className="card-body">
                <ReportDetails data={report} />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="card">
          <div className="card-body">
            <h4 className="text-center text-danger">
              ⚠️ Measurement Sheet Not Found! <br /> ID {id}
            </h4>
          </div>
        </div>
      )}
    </div>
  );
}

export default CircularDetails;
